module.exports = __webpack_public_path__ + "img/money-bag.6259f738.svg";